export const shouldWaitForCreatedDraftRoute = (
  isNewEntry: boolean,
  createdEntryId: string | null,
) => isNewEntry && Boolean(createdEntryId);
